import * as Yup from "yup";
import dayjs from "dayjs";

export const validationSchema = Yup.object({
    initialDate: Yup
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    uomId: Yup
        .string()
        .required("Required"),
    locationId: Yup
        .string()
        .required("Required"),
    qty: Yup.lazy((val) => {

        let maxQty = val?.maxQty? val.maxQty : 0

        let valueSchema;

        valueSchema = Yup
            .number("")
            .typeError("Invalid")
            // .min(parseFloat(minQty))
            .max(parseFloat(maxQty), `Max : ${maxQty}`)
            .positive("More than 0")
            .required("Required")

        return Yup.object().shape({
            value: valueSchema,
            maxQty: Yup.mixed().nullable().typeError("Invalid")
        })
            

    }),
})

export const initialValues = {
    initialDate: dayjs(),
    locationId: "",
    locationDisplay: "",
    qty: {
        value: "",
        maxQty: 30,
    },
    uomId: "",
    uomName: "",
    remark: ""
    
}